// exp_PORTFOLIO-61587_file
import fetcher from 'api/fetcher';
import axios, { AxiosError } from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';

import { addMagritteNotification } from 'store/models/notification';
import { setVacancyOfTheDayModalVisible } from 'store/models/vacancyOfTheDay';
import { AppThunkAction } from 'store/utils';

export const hideVacancyOfTheDay = (): AppThunkAction => (dispatch) =>
    fetcher
        .post('/api/v1/vacancy_of_the_day/fakedoor/hide', {})
        .then(() => {
            dispatch(setVacancyOfTheDayModalVisible(true));
        })
        .catch((error: AxiosError) => {
            if (axios.isCancel(error)) {
                return;
            }

            dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
        });
